import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import MD5 from 'md5'

@Injectable({
  providedIn: 'root'
})
export class IntegratorService {

  private factura:any;

  constructor(
    private http: HttpClient
  ) { }

  private setHeaders(): HttpHeaders {
    const headerConfig = {
       'Content-Type': 'application/json',
       'Accept': 'application/json'
      };
    return new HttpHeaders(headerConfig);
  }

  public integrator(contact, datas) {
    this.factura = datas;
    contact = typeof contact !== 'undefined' ? contact : {}
    // Production
    var integratorEndPoint = 'https://content.mundojoven.com/integrator-ws/getchallenge?username=enginesuser'
    // var integratorEndPoint = '//34.209.201.58:8080/integrator-ws/getchallenge?username=enginesuser'

    let self = this;
        
    return this.http.get(integratorEndPoint, { headers: this.setHeaders() }).subscribe((data: any) => {
        // handle success
        var newAck = 'BlqNO1pVefRnLuA6'
        var newKey = MD5(data.token + newAck)
        let integrator = {
          step: 1,
          data: data,
          error: null
        }
        sessionStorage.setItem('integrador', JSON.stringify(integrator));
        return self.login(contact, newKey)
    }, (err) => {
      let integrator = {
        step: 1,
        data: null,
        error: err
      }
      sessionStorage.setItem('integrador', JSON.stringify(err));
    });
  }

  public login (contact, newKey) {
    // Production
    var integratorLogEndPoint = 'https://content.mundojoven.com/integrator-ws/login?username=enginesuser&acceskey='
    // var integratorLogEndPoint = '//34.209.201.58:8080/integrator-ws/login?username=enginesuser&acceskey='

    console.log('Login integrador')

    let self = this;

    return this.http.post(integratorLogEndPoint + newKey, null, { headers: this.setHeaders() }).subscribe((data: any) => {
        const integrator = {
          step: 2,
          data: data,
          error: null
        }
        sessionStorage.setItem('integrador', JSON.stringify(integrator));
        return self.nuxiba(contact, data);
      }, (err) => {
        let integrator = {
          step: 2,
          data: null,
          error: err
        }
        sessionStorage.setItem('integrador', JSON.stringify(integrator));
        return err;
      });

  }


  public nuxiba (contacto, data) {
    var sessname = data.sessionname
    var assignUser = '19x112';
    var accountId = '11x160001';
    var productId = '14x182219';

    let self = this

    var nuxibaRequest = {
      'sessionname': sessname,
      'contact': {
        'account_id': accountId,
        'assigned_user_id': assignUser,
        'birthday': '',
        'description': 'Cliente Web',
        'contactmode': 'Email',
        'fullname': self.omitirAcentos(contacto.customer.name + ' ' + self.omitirAcentos(contacto.customer.lastName)),
        //'firstname': self.omitirAcentos(contacto.customer.lastName),
        'lastname': self.omitirAcentos(contacto.customer.lastName),
        'email': contacto.customer.email,
        //'phone': contacto.customer.phone,
        'mobile': contacto.customer.mobile,
        'state': '',
        'branch': '',
        'companyname': self.omitirAcentos(contacto.invoice.name),
        'rfc': contacto.invoice.rfc
      },
      'quote': {
        'quote_no': '',
        'subject': 'Cotizacion Seguros Web',
        'potential_id': '',
        'quotestage': 'Created',
        'validtill': '',
        'contact_id': '',
        'carrier': '',
        'hdnSubTotal': '0.00000000',
        'shipping': '',
        'assigned_user_id1': '',
        'txtAdjustment': '0.00000000',
        'hdnGrandTotal': '0.00000000',
        'hdnTaxType': 'group',
        'discount_percent': '',
        'discount_amount': '',
        'hdnS_H_Amount': '0.00000000',
        'account_id': accountId,
        'assigned_user_id': assignUser,
        'createdtime': '',
        'modifiedtime': '',
        'modifiedby': '',
        'currency_id': '21x1',
        'conversion_rate': '1.000',
        'bill_street': this.factura.street + ' ' + this.factura.ext + ' ' + this.factura.int + ' ' + this.factura.apartment,
        'ship_street': '',
        'bill_city': this.factura.town?this.factura.town:'',
        'ship_city': '',
        'bill_state': this.factura.state?this.factura.state:'',
        'ship_state': '',
        'bill_code': this.factura.zipCode,
        'ship_code': '',
        'bill_country': 'Mexico',
        'ship_country': '',
        'bill_pobox': this.factura.suburb?this.factura.suburb:'',
        'ship_pobox': '',
        'description': '',
        'terms_conditions': '',
        'productid': productId,
        'quantity': '1',
        'listprice': '1',
        'comment': '',
        'tax1': '',
        'tax2': '',
        'tax3': '',
        'pre_tax_total': '0.00000000',
        'hdnS_H_Percent': '',
        'created_date': '',
        'end_date': '',
        'next_call': '',
        'email': contacto.customer.email,
        'trip_type': '',
        'departure_airport': '',
        'arrival_airport': '',
        'departure_oj_airport': '',
        'arrival_oj_airport': '',
        'departure_date': JSON.parse(window.sessionStorage.getItem('product')).vouchers[0].dateFrom,
        'arrival_date': JSON.parse(window.sessionStorage.getItem('product')).vouchers[0].dateTo,
        'booking_class': '',
        'adt_qty': JSON.parse(window.sessionStorage.getItem('totales')).totalViajeros, // $rootScope.$storage.step1.passengers.length,
        'chd_qty': '',
        'inf_qty': '',
        'flexible_date': '',
        'pax_visa': '',
        'pnr': '',
        'pax_detail': '',
        'closereason': '',
        'paymentdetail': '',
        'orderstatus': '',
        'intelisisorder': '',
        'history': '',
        'priceadjustment': '',
        'needauth': '',
        'authstatus': '',
        'mktorigin': '', // Tipo Reserva
        'paxname': '',
        'paxlastname': '',
        'paxbirthday': '',
        'webproduct': '',
        'program': '',
        'provider': '', // Aerolinea
        'campaign': '',
        'destinationcountry': '',
        'destinationcity': '',
        'duration': '',
        'paxnumber': '',
        'language': '',
        'languagelevel': '',
        'interestlevel': '',
        'coursetype': '',
        'travellive': '',
        'url': '',
        'utmsource': '', // (typeof sessionStorage.getItem('utm_source') !== 'object') ? sessionStorage.getItem('utm_source') : '',
        'utmmedium': '', // (typeof sessionStorage.getItem('utm_medium') !== 'object') ? sessionStorage.getItem('utm_medium') : '',
        'utmcampaign': '', // (typeof sessionStorage.getItem('utm_campaign') !== 'object') ? sessionStorage.getItem('utm_campaign') : '',
        'nuxibasent': '',
        'sentdate': '',
        'senthour': '',
        'region': '',
        'interfacesent': '',
        'interfaceerror': '',
        'interfacesentdate': '',
        'interfacesenthour': '',
        'nuxibaerror': '',
        'consoletag': '',
        'quotebranch': '',
        'nuxibaphones': '',
        'subqualification': '',
        'intelisisstatus': '',
        'corestatus': '',
        'billstatus': '',
        'billemail': contacto.emailfactura,
        'newpnr': '',
        'emergencypaxname': self.omitirAcentos(JSON.parse(window.sessionStorage.getItem('passengerData')).name_em),
        'emergencypaxemail': '',
        'emergencypaxtelephone': JSON.parse(window.sessionStorage.getItem('passengerData')).phone_em,
        'paymentmethod': 'pago_unico', // $rootScope.$storage.step2.payment_information.payment_option, // check
        'paymentstatus': '',
        'paymentreference': '',
        'paymentmessage': '',
        'paymentmessagetopurchaser': '',
        'paymentautcode': '',
        'qualification': '',
        'id': '',
        'insuredobject': self.toCamel(JSON.parse(window.sessionStorage.getItem('passengerData')).passengerDataList), // check
        'lineItems': [{
          'productid': productId,
          'quantity': '1',
          'listprice': JSON.parse(window.sessionStorage.getItem('product')).totalPrice // $rootScope.$storage.init_total // check
        }]
      }
    }

    var urlSaveComplex = 'https://content.mundojoven.com/integrator-ws/savecomplexcontact'
    // var urlSaveComplex = '//34.209.201.58:8080/integrator-ws/savecomplexcontact'

    return this.http.post(urlSaveComplex, JSON.stringify(nuxibaRequest), {headers: {'Content-Type': 'application/json'}}) .subscribe((data: any) => {
        // handle success
        // ContactID
        let integrator = {
          step: 3,
          data: data,
          error: null
        }
        sessionStorage.setItem('integrador', JSON.stringify(integrator));
        // data.contact.contact_id
        return data
      }, (err) => {
        let integrator = {
          step: 3,
          data: null,
          error: err
        }
        sessionStorage.setItem('integrador', JSON.stringify(integrator));
        return err
      });

  }

  public omitirAcentos (text) {
    if (text.length !== 0) {
      var acentos = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç'
      var original = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc'
      for (var i = 0; i < acentos.length; i++) {
        text = text.replace(acentos.charAt(i), original.charAt(i))
      }
      return text
    } else {
      return text
    }
  }

  public toCamel (o) {
    var build, key, destKey, value
    let self = this
    if (o instanceof Array) {
      build = []
      for (key in o) {
        value = o[key]
        if (typeof value === 'object') {
          value = self.toCamel(value)
        }
        build.push(value)
      }
    } else {
      build = {}
      for (key in o) {
        if (o.hasOwnProperty(key)) {
          destKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString()
          value = o[key]
          if (value !== null && typeof value === 'object') {
            value = self.toCamel(value)
          }
          build[destKey] = value
        }
      }
    }
    return build
  }

  public purchase (dataPurchase) {
    // Production
    var purchaseURL =  'https://seguros-new.mundojoven.com/purchase/getIssues'//'https://seguros-mundojoven.com/purchase/getIssues'
    return this.http.post(purchaseURL, dataPurchase,{ headers: this.setHeaders() });
  }

  public operatingConsoleInsurance(numberQuote) {
    const endpoint = `https://fuv-back.mundojoven.com/fuv_core_api/operatingConsole/retrieveInformation/${numberQuote}`;
    return this.http.get(endpoint, { headers: this.setHeaders() });
  }

  public updateInformation (numberQuote, respData, dataPurchase) {

    const _respData = {
      ...respData,
      ordenStatus: respData.paymenStatus,
      subClassification: '',
      conektaCommission: dataPurchase.payment.commission,
      quantity: dataPurchase.payment.total,
      closingReason: '',
      rating: '',
      idBuy: '',
      paymentMethod: 'conekta',
      paymentStatus: respData.paymenStatus,
      paymentMessage: respData.message,
      deferredMonths: dataPurchase.payment.month,
      acceptTermsAndConditions: 'true',
      purchaseError: respData.paymenStatus,
      purchaseCanceled: '',
      addedSuitcase: '',
      insuranceAdded: dataPurchase.passengers[0].voucherProductId,
      utm: ''
    }

    const endpoint = `https://fuv-back.mundojoven.com/fuv_core_api/operatingConsole/updateInformation/${numberQuote}`;
    return this.http.post(endpoint, _respData, { headers: this.setHeaders() });
  }

}
